// extracted by mini-css-extract-plugin
export default {"wishlistButton":"style_wishlistButton__YP8Zd","wishlistHeader":"style_wishlistHeader__Rd7Zr","wishlistSubHeader":"style_wishlistSubHeader__rFRhy"};